import React, { useEffect, useRef } from 'react';
import './NavMenus.css';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../LanguagePrefix';

function NavSolutions({ onClose, buttonRef }) {
    const menuRef = useRef(null);
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();


    return (
        <div className='nav-menu-popup' ref={menuRef} style={{ width: "200px", left: -50 }}>
            <div className='d-flex justify-content-center' style={{ marginTop: -10 }}>
                <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.67777 2.24264C12.0209 -0.100505 15.8199 -0.100505 18.1631 2.24264L25.5981 9.67767C29.3779 13.4575 26.7009 19.9203 21.3554 19.9203H13.9204L6.48538 19.9203C1.13996 19.9203 -1.53705 13.4575 2.24274 9.67767L9.67777 2.24264Z" fill="#fff" />
                </svg>
            </div>
            <div className='nav-content'>
                <div className='nav-grid-1col'>
                    <a href={`${langPrefix}/hotel-management-software/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Hotels')}</label>
                        </div>
                    </a>
                    <a href={`${langPrefix}/multi-property-groups/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Multi-Property Groups')}</label>
                        </div>
                    </a>
                    <a href={`${langPrefix}/vacation-rentals/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Vacation Rentals')}</label>
                        </div>
                    </a>
                    <a href={`${langPrefix}/bed-breakfast/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Bed & Breakfasts')}</label>
                        </div>
                    </a>
                    <a href={`${langPrefix}/small-hotels/`} style={{ textDecoration: 'none' }} className='nav-grid-element d-flex align-items-start'>
                        <div className='d-flex flex-column align-items-start'>
                            <label>{t('Small Hotels')}</label>
                        </div>
                    </a>
                </div>
            </div>
        </div >
    );
}

export default NavSolutions;